import { Asset } from './asset.interface';
import { DisplayData } from './display-data.interface';

export class Holding implements DisplayData {
	private colour: string = '';
	private highLevelAssetClass: string = '';

	constructor(public asset: Asset, public weight: number, public value: number, public subType: string, public hasErrors: boolean) { }

	public getAsset(): Asset {
		return this.asset;
	}

	public getName(): string {
		return this.asset.getName();
	}

	public getWeight(): number {
		return this.weight ? this.weight : 0;
	}

	public getValue(): number {
		return this.value ? this.value : 0;
	}

	public getSubType(): string {
		return this.subType;
	}

	public getColour(): string {
		return this.colour;
	}

	public getHighLevelAssetClass(): string {
		return this.highLevelAssetClass;
	}

	public setHighLevelAssetClass(highLevelAssetClass: string): void {
		this.highLevelAssetClass = highLevelAssetClass;
	}

	public setWeight(weight: number): void {
		this.weight = weight;
	}

	public setValue(value: number): void {
		this.value = value;
	}

	public setColour(colour: string): void {
		this.colour = colour;
	}

	public setAsset(asset: Asset): void {
		this.asset = asset;
	}

	public isErroneous(): boolean {
		return this.hasErrors;
	}
}
